import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { useAngularIsReady } from '@bai/features/angular-integration';
import { RoleNames } from '@bai/utils/types';

import { setUserRole, useHasRole } from '../AuthProvider';

export function HandleUserRole({
  baiRole,
  allowAuthor = false,
  redirectIfRoleNotFound = true,
}: {
  baiRole: RoleNames;
  allowAuthor?: boolean;
  redirectIfRoleNotFound?: boolean;
}) {
  const hasRole = useHasRole(baiRole);
  const hasTaRole = useHasRole(RoleNames.TA);
  const hasAuthorRole = useHasRole(RoleNames.Author);
  const navigate = useNavigate();
  const angularIsReady = useAngularIsReady();
  const resolvedRole = hasRole
    ? baiRole
    : allowAuthor && hasAuthorRole
      ? RoleNames.Author
      : null;

  useEffect(() => {
    if (!angularIsReady || !resolvedRole) return;
    const taOverrideRole = hasTaRole ? RoleNames.TA : resolvedRole;

    // handles the expected role of TA for TA's viewing student certs
    const useTaOverrideRole = window.location.pathname.includes(
      'courses/certificate/assignments',
    );

    // NOTE: This is a legacy integration. When first going to a route that is attached to a role, we update the Angular service with the new role.
    setUserRole(
      useTaOverrideRole && resolvedRole === RoleNames.TA
        ? taOverrideRole
        : resolvedRole,
    ).catch((e) => console.error('Error setting user role', e));
  }, [angularIsReady, resolvedRole, hasTaRole]);

  useEffect(() => {
    if (!resolvedRole && redirectIfRoleNotFound) {
      navigate('/student/home', { replace: true });
    }
  }, [navigate, redirectIfRoleNotFound, resolvedRole]);

  return null;
}
